
var article = `
## Heroe...

Si aparece solamente **initramfs** al iniciar la máquina, hacer:

> *(initramfs)* exit
    
Y aparecerá **dónde** está el *error* que hay que reparar, por ejemplo:

> **/dev/sda6**: UNEXPECTED INCONSISTENCY; RUN fsck MANUALLY.
    
La solución es tan fácil como usar **fsck -f** seguido de la partición que se debe arreglar:

> *(initramfs)* fsck -f /dev/**sda6**

Donde reemplazo **sda6** con la partición que corresponda.

Durante el proceso de reparación de archivos preguntará si quiero continuar en algunos momentos. Siempre decir que **sí**.

Una vez que llegue al final (**puede tardar 1 hora**), ejecutar:

> *(initramfs)* exit

Y el sistema se inicia normalmente.

### ¿Qué es fsck?

**fsck** es una utilidad de los sistemas *Unix* y similares, como *Linux*, *AIX* y *MAC OS X* que se utiliza ante alguna inconsistencia del sistema de archivos para corregir los posibles errores en el sistema. ([enlace a Wikipedia](https://es.wikipedia.org/wiki/Fsck))
`

export default article